/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Release_HelpInputs */

const en_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How quickly audio returns to normal (ms) after VO ends`)
};

const fr_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse de retour au niveau normal (ms) après la fin de la VO`)
};

const de_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schnell der Ton nach dem Ende des Voiceovers wieder in den Normalzustand zurückkehrt (ms).`)
};

const it_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto velocemente l'audio torna alla normalità (ms) dopo la fine della voce`)
};

const ru_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорость возвращения звука к нормальному состоянию (мс) после окончания озвучки.`)
};

const es_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué tan rápido el audio vuelve a la normalidad (ms) después de que finaliza la voz en off`)
};

const zh_cn2_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO结束后音频恢复正常所需的时间（毫秒）`)
};

const ja_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO終了後、音声が正常に戻るまでの時間（ミリ秒）`)
};

const hi_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वॉयस ओवर समाप्त होने के बाद ऑडियो कितनी जल्दी सामान्य स्थिति में लौटता है (मिलीसेकंड में)`)
};

const pt_pt2_audio_description_export_automix_release_help = /** @type {(inputs: Audio_Description_Export_Automix_Release_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que rapidez o áudio retorna ao normal (em milissegundos) após o término da narração.`)
};

/**
* | output |
* | --- |
* | "How quickly audio returns to normal (ms) after VO ends" |
*
* @param {Audio_Description_Export_Automix_Release_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_release_help = /** @type {((inputs?: Audio_Description_Export_Automix_Release_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Release_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_release_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_release_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_release_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_release_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_release_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_release_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_release_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_release_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_release_help(inputs)
	return en_audio_description_export_automix_release_help(inputs)
});